import { get, post } from '../axios'

// 分页查询
export function post_abDevice_page(map) {
  return post(`${process.env.VUE_APP_ABTEST}/abDevice/page`, map)
}

// 查询所有设备
export function post_abDevice_queryAll(map) {
  return post(`${process.env.VUE_APP_ABTEST}/abDevice/queryAll`, map)
}

// 删除设备
export function get_abDevice_remove(map) {
  return get(`${process.env.VUE_APP_ABTEST}/abDevice/remove`, map)
}

// 保存设备
export function post_abDevice_save(map) {
  return post(`${process.env.VUE_APP_ABTEST}/abDevice/save`, map)
}
